import { NEAR_ZERO_THRESHOLD } from "../../core/utils";
import { Cartesian3, Ray } from "cesium";
export class CornerSlopeStrategy {
    getSlopePoint(pointInfo, verticalDirection, setting) {
        // side slope
        const verticalVec = Cartesian3.multiplyByScalar(verticalDirection, setting.slopeHeight, new Cartesian3());
        const width = setting.moundSlope * setting.slopeHeight;
        const horizontalVec = Cartesian3.multiplyByScalar(pointInfo.outwardDirection, width, new Cartesian3());
        const slopeVec = Cartesian3.add(verticalVec, horizontalVec, new Cartesian3());
        const point = Cartesian3.add(pointInfo.position, slopeVec, new Cartesian3());
        const ray = new Ray(pointInfo.position, Cartesian3.normalize(slopeVec, new Cartesian3()));
        return { ray, point };
    }
    getShelfPoint(pointInfo, verticalDirection, setting) {
        // berm slope
        const horizontalVec = Cartesian3.multiplyByScalar(pointInfo.outwardDirection, setting.shelfWidth, new Cartesian3());
        let height = 0;
        if (setting.shelfSlope !== 0 &&
            Math.abs(setting.shelfSlope) > NEAR_ZERO_THRESHOLD) {
            height = setting.shelfWidth / setting.shelfSlope;
        }
        else {
            height = 0;
        }
        const verticalVec = Cartesian3.multiplyByScalar(verticalDirection, height, new Cartesian3());
        const slopeVec = Cartesian3.add(verticalVec, horizontalVec, new Cartesian3());
        const point = Cartesian3.add(pointInfo.position, slopeVec, new Cartesian3());
        const ray = new Ray(pointInfo.position, Cartesian3.normalize(slopeVec, new Cartesian3()));
        return { ray, point, height };
    }
}
//# sourceMappingURL=cornor-slope-strategy.js.map